import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

const deleteGitSkillSourceSchema = z.object({
  sourceId: z.string(),
});

export const deleteGitSkillSource = mutator({
  schema: deleteGitSkillSourceSchema,
  resolve: {},
  permissions: [
    {
      permission: "tenant:skill_create",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args: { sourceId } }) => {
    const [source] = await tx.run(
      zql.skillGitSources
        .where("id", sourceId)
        .where("createdByUserId", ctx.userId)
        .related("installations")
    );
    if (!source) return;
    if (source.installations.length > 0) {
      throw userFacingError("This Git source has installed skills");
    }
    await tx.mutate.skillGitSources.delete({ id: source.id });
  },
});
